import {createSelector} from 'reselect';

const shopsSelector = (state) => state.shops;
             
export const getShops = createSelector(
    [shopsSelector],
    state => state.list
);